'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var Select = require('react-select');
var Icon = require('../../Icon/Icon.js');

var ClearIndicator = function (props) { return (jsxRuntime.jsx(Select.components.ClearIndicator, _tslib.__assign({}, props, { children: jsxRuntime.jsx(Icon["default"], { name: "Close" }) }))); };
var DropdownIndicator = function (props) { return (jsxRuntime.jsx(Select.components.DropdownIndicator, _tslib.__assign({}, props, { children: jsxRuntime.jsx(Icon["default"], { name: "CaretDownFill" }) }))); };
var MultiValueRemove = function (props) { return (jsxRuntime.jsx(Select.components.MultiValueRemove, _tslib.__assign({}, props, { children: jsxRuntime.jsx(Icon["default"], { name: "Close" }) }))); };

exports.ClearIndicator = ClearIndicator;
exports.DropdownIndicator = DropdownIndicator;
exports.MultiValueRemove = MultiValueRemove;
//# sourceMappingURL=customComponents.js.map
